<section
  class="app-dialog configuracion-notice-dialog"
  [class.configuracion-notice-dialog--confirmation]="data.tone === 'confirmation'"
  [class.configuracion-notice-dialog--success]="data.tone === 'success'"
  [class.configuracion-notice-dialog--error]="data.tone === 'error'">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <div class="configuracion-notice-dialog__icon" aria-hidden="true">
        <mat-icon>{{ iconByTone[data.tone] }}</mat-icon>
      </div>

      <div>
        <p class="app-dialog__eyebrow">{{ data.eyebrow }}</p>
        <h2>{{ data.title }}</h2>
      </div>
    </div>

    <button
      type="button"
      mat-icon-button
      class="app-dialog__close"
      aria-label="Cerrar diálogo"
      (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div mat-dialog-content class="app-dialog__content">
    <p class="configuracion-notice-dialog__message">{{ data.message }}</p>
  </div>

  <footer mat-dialog-actions class="app-dialog__footer configuracion-notice-dialog__footer">
    <button
      *ngIf="data.cancelText"
      type="button"
      class="app-form-btn app-form-btn--compact configuracion-notice-dialog__button--cancel"
      (click)="cancel()">
      {{ data.cancelText }}
    </button>

    <button
      type="button"
      class="app-form-btn app-form-btn--compact"
      [class.app-form-btn--danger]="data.tone === 'confirmation'"
      [class.app-form-btn--primary]="data.tone !== 'confirmation'"
      (click)="confirm()">
      {{ data.confirmText }}
    </button>
  </footer>
</section>
